import type { ProjectMember as GraftProjectMember } from '@graft/nuget-gc.webportals.projects'

import { MemberLevel } from '@common/modules/settings/enums/member-level.enum'
import { MemberStatus } from '@common/modules/settings/enums/member-status.enum'
import type { WorkspaceMember } from '@common/modules/settings/types/workspace-member.type'

export async function projectMemberToObject(entity: GraftProjectMember, projectId: string): Promise<WorkspaceMember> {
  const [userId, firstName, lastName, email, avatarUrl, level, invitationPending] = await Promise.all([
    entity.get_userId(),
    entity.get_firstName(),
    entity.get_lastName(),
    entity.get_email(),
    entity.get_avatarUrl(),
    entity.get_level(),
    entity.get_invitationPending(),
  ])

  const nameParts = [firstName, lastName].flatMap((s) => {
    const part = s?.trim()
    return part ? [part] : []
  })
  const name = nameParts.length ? nameParts.join(' ') : null
  const emailValue = email ?? ''
  const id = userId || emailValue || `project-member-${projectId}-${name ?? 'unknown'}`
  const role = level === MemberLevel.ADMIN ? MemberLevel.ADMIN : MemberLevel.DEVELOPER

  return {
    id,
    name,
    email: emailValue,
    avatarUrl: avatarUrl?.trim() || null,
    role,
    status: invitationPending ? MemberStatus.PENDING : MemberStatus.ACTIVE,
    lastSeen: null,
    projectIds: [projectId],
  }
}
